import axios from '../config.js';
const resource = '/case/diagnosis';
const resource2 = '/medicine/code';

export default {
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
  update(id='', payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    
    var data = {
      _method: 'PUT',
      ...payload
    }

    return axios.put(`${resource}/${id}`, data);
  },
  delete(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.delete(`${resource}/${id}`);
  },

  updateFavorites (data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.post(`${resource2}/fav`, data);
  },

  getFavorites () {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.get(`${resource2}/fav`);
  },

  updateMostUsed (data) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    axios.defaults.headers.common['Content-Type'] = `application/json`
    return axios.post(`${resource2}/most/used`, data)
  }
};